import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import useStyles from './PasswordRequirements.styles';
const PasswordRequirements = ({ signUp, requirements }) => {
    const { classes } = useStyles();
    return (_jsxs("div", { className: classes.passwordRequirements, children: [_jsx("p", { className: classes.passwordCaption, children: signUp ? 'Passwords should include:' : 'Your new password should include:' }), _jsx("ul", { children: requirements.map((requirement) => (_jsx("li", { children: _jsx("span", { className: clsx(classes.label, requirement.status === 'success' && classes.success, requirement.status === 'error' && classes.error), children: requirement.label }) }, requirement.label))) })] }));
};
export default PasswordRequirements;
